<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/search.json"></i18n>
<i18n src="@/lang/table.json"></i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <el-button-group>
          <el-button
            type="primary"
            v-t="'actions.add_new'"
            @click="handleAction('add_new')"
          />
        </el-button-group>
      </template>
    </component>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        sortable
        :label="$t('table.customer')"
        prop="customerName"
        v-if="!is_in_customer_datails || (vars.customer && vars.amo)"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-error"
            style="color:red"
            v-if="scope.row.canDelete"
          ></i>
          <span style="margin-left: 10px">{{ scope.row.customerName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        :label="$t('table.amocrm')"
        prop="amoDomain"
        v-if="!is_in_customer_datails || (vars.customer && !vars.amo)"
      ></el-table-column>
      <el-table-column
        :label="$t('table.apikey')"
        prop="apiKey"
      ></el-table-column>
      <el-table-column
        sortable
        :label="$t('table.service')"
        prop="code"
      ></el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            v-model="search"
            size="mini"
            :placeholder="$t('search.placeholder')"
            spa-action="find"
          />
        </template>
        <template slot-scope="scope">
          <el-dropdown
            split-button
            size="small"
            type="info"
            trigger="click"
            @click="handleEdit(scope.$index, scope.row)"
            @command="
              (...args) => {
                handleAction(args[0], scope.$index, scope.row);
              }
            "
          >
            {{ $t("actions.view") }}
            <el-dropdown-menu>
              <el-dropdown-item command="open_for_edit"
                >{{ $t("actions.edit") }}
              </el-dropdown-item>
              <el-dropdown-item
                :disabled="!scope.row.canDelete"
                command="delete"
                >{{ $t("actions.delete") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <component
      :is="require('../_snippets/popup/popup_912x616').default"
      :visible.sync="show_selected"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <template slot="content" v-if="show_selected">
        <el-container>
          <el-main>
            <sub-element
              ref="service_card"
              :value="
                Object.assign(
                  Object.create(Object.getPrototypeOf(cur_selected)),
                  cur_selected
                )
              "
              @action="handleAction"
            />
          </el-main>
        </el-container>
      </template>
    </component>
  </el-main>
</template>

<script>
import { mapGetters } from "vuex";
import SubElement from "../_snippets/sub_elements/sub-element-contact";
import SharedCustomersServices from "../../store/classes/SharedCustomersServices";

export default {
  name: "customers_services_list",
  components: { SubElement },
  props: {
    request_vars: {
      type: Object,
      default: () => {
        return {};
      }
    },
    is_in_customer_datails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: null,
      vars: this.request_vars,
      cur_selected: null,
      show_selected: false
    };
  },
  created() {
    // if (this.skip_created){
    //     return;
    // }
    this.getData();
  },
  watch: {
    request_vars: {
      handler: function() {
        this.$log(this.request_vars);
        this.vars = this.request_vars;
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    test(...args) {
      console.log(args);
    },
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    handleAction(name, params, model) {
      this.$log(arguments);
      switch (name) {
        case "save":
          Object.assign(this.cur_selected, model);
          break;
        case "delete":
          model._handleDelete().then(res => {
            this.getData();
          });
          break;
        case "open_for_edit":
          this.handleEdit(params, model);
          setTimeout(() => {
            this.$refs.service_card.cur_edit_mode = true;
          }, 10);
          break;
        case "add_new":
          // eslint-disable-next-line no-case-declarations
          let t = new SharedCustomersServices({});
          this.services.unshift(t);
          this.handleAction("open_for_edit", this.services.length - 1, t);
          break;
        case "cancel":
          if (model.uuid) {
            break;
          }
          this.services.shift();
        // eslint-disable-next-line no-fallthrough
        case "close":
          this.cur_selected = null;
          this.show_selected = false;
          break;
      }
    },
    handleEdit(index, row) {
      this.$log(index, row);
      this.cur_selected = row;
      this.show_selected = true;
    }
  },
  computed: {
    ...mapGetters({
      services_getter: "shared_customers_services_list/services"
    }),
    services() {
      return this.services_getter();
    },
    refetchQueries() {
      return [
        {
          query: require("../../graphql/services/services_list.graphql"),
          variables: this.vars
        }
      ];
    },
    tableData() {
      return Object.values(this.services).filter(v => {
        return v.beShownForFilterString(this.search);
      });
    }
  }
};
</script>

<style scoped></style>
